import { Injectable } from '@angular/core';
import { hslToHex } from '@shiftbase-com/utilities';

@Injectable({
  providedIn: 'root',
})
export class ChartThemeService {
  private colorBySizeCache: Record<number, string[]> = {};

  getColorsByDataSize(size: number): string[] {
    if (this.colorBySizeCache[size]) {
      return this.colorBySizeCache[size];
    }
    const colors = this.generateColorsBySize(size);
    this.colorBySizeCache[size] = colors; // cache the colors
    return colors;
  }

  private generateColorsBySize(size: number): string[] {
    return Array.from({ length: size }, (_, i) => this.getColorBySize(size, i));
  }

  private getColorBySize(size: number, index: number): string {
    const hslColor = Math.round((360 / size) * index);
    const hexColor = hslToHex(hslColor, 100, 65);
    return hexColor;
  }
}
